import type { ReactNode } from 'react';
import type { RouteObject } from 'react-router-dom';

// project imports
import AuthLayout from 'layout/BHSi/AuthLayout';
import LoginPage from 'pages/auth/LoginPage';
import TwoFactorPage from 'pages/auth/TwoFactorPage';
import ResetPasswordPage from 'pages/auth/ResetPasswordPage';

type AuthRouteProps = {
  children: ReactNode;
};

function AuthRoute({ children }: AuthRouteProps) {
  return <AuthLayout>{children}</AuthLayout>;
}

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes: RouteObject[] = [
  {
    path: '/',
    element: (
      <AuthRoute>
        <LoginPage />
      </AuthRoute>
    )
  },
  {
    path: '/login',
    element: (
      <AuthRoute>
        <LoginPage />
      </AuthRoute>
    )
  },
  {
    path: '/reset-password',
    element: (
      <AuthRoute>
        <ResetPasswordPage />
      </AuthRoute>
    )
  },
  {
    path: '/2fa',
    element: (
      <AuthRoute>
        <TwoFactorPage />
      </AuthRoute>
    )
  }
];

export default LoginRoutes;
